import type { DirectusCompany } from '@/types/directus-types'
import { directusReadSingletonItem } from './helperFunctions'

/** API Call to fetch the company details from the DB.
 *
 * @returns a user `CompanyData` object if successful. Undefined if not.
 */
export async function fetchFleetData(): Promise<DirectusCompany | undefined> {
  const collection = 'Company'
  const query = {
    fields: [
      'Name',
      'Logo',
      'allow_vehicle_booking',
      'allow_private_charger_booking',
      'third_party_vehicle_booking_only',
      'third_party_vehicle_booking_url',
    ],
  }

  const res = await directusReadSingletonItem<DirectusCompany>(collection, query)
  return res
}
